import React from 'react';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Tienes entre 40 y 50 años y sientes dolor punzante en el glúteo o la pierna al despertar', 'Sientes electricidad, hormigueo o calor bajando por la pierna', 'Ya estás tomando medicación pero no recuperas movilidad real', "Pasas muchas horas sentado o conduciendo y vives con miedo de quedarte 'trabado'", 'Has probado estiramientos de YouTube, fisioterapia o reposo y no ves resultados sostenidos', 'Quieres una solución que funcione hoy, en casa, sin equipo'];
  const notFor = ['Si buscas una rutina de gimnasio o levantamiento de pesas — esto no es para ti', 'Si esperas resultados sin hacer absolutamente nada — el protocolo requiere 7 minutos activos de tu parte', 'Si tienes señales de emergencia médica (pérdida de control de esfínteres, debilidad severa de pierna) — para primero, llama al médico hoy'];
  return <section className="bg-slate-50 py-24 px-4" data-id="element-13">
      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-15">
          {/* Para quién ES */}
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border-t-8 border-green-500" data-id="element-16">
            <h3 className="text-3xl font-extrabold text-slate-900 mb-8" data-id="element-17">
              Este protocolo fue construido pensando en ti si:
            </h3>
            <ul className="space-y-6" data-id="element-18">
              {isFor.map((text, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-19">
                  <div className="bg-green-100 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-20">
                    <Check className="w-5 h-5 text-green-600" data-id="element-21" />
                  </div>
                  <span className="text-lg text-slate-700 font-medium leading-relaxed" data-id="element-22">
                    {text}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO ES */}
          <div className="bg-slate-100 p-8 md:p-10 rounded-3xl border-t-8 border-red-500" data-id="element-23">
            <h3 className="text-3xl font-extrabold text-slate-900 mb-8" data-id="element-24">
              Sé honesto contigo mismo. Esto NO es para ti si:
            </h3>
            <ul className="space-y-6" data-id="element-25">
              {notFor.map((text, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-26">
                  <div className="bg-red-200 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-27">
                    <X className="w-5 h-5 text-red-600" data-id="element-28" />
                  </div>
                  <span className="text-lg text-slate-700 font-medium leading-relaxed" data-id="element-29">
                    {text}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}